import classes from "./Hero.module.scss";
import hero from "../../assets/img/img-mv.jpg";

const Hero = (props) => {
  const { title } = props;
  return (
    <div className={classes.hero}>
      <h2 className={classes.head}>{title}</h2>
      <img src={hero} alt="" className={classes.bgimg} />
    </div>
  );
};

export default Hero;
